import Big from "big.js";
import { OfferingOption } from "../CenterPackageOfferingSelectField/types";
import { Offering } from "./types";

const getOfferingsDurationMinutes = (params: {
  offerings: Offering[];
  selectedOptions: OfferingOption[];
}) => {
  const { offerings, selectedOptions } = params;

  const durationBig = offerings.reduce((acc, offering) => {
    const { id, durationMinutes } = offering;

    const isOfferingSelected = selectedOptions.some(
      (option) => option.id === id,
    );

    return isOfferingSelected ? acc.plus(durationMinutes) : acc;
  }, Big(0));

  return durationBig.toNumber();
};

export default getOfferingsDurationMinutes;
